module.exports = __webpack_public_path__ + "static/media/oberflex-ebenedesphilippines-2560x1440.17f7fb56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-ebenedesphilippines-2560x1440.jpg
// module id = 1003
// module chunks = 37